
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useState } from 'react';
import {
    getMyLinkedhotels, gethotelcleaners, updateemployeetoroosterv2
} from "../dbconnector/connector";
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";

import './css/tabs.css';

import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import LoadingSpinner from '../customNodes/LoadingSpinner';







const NotPresent = (props) => {

    const [linkedhotels, setlinkedhotels] = useState([]);
    const [linkedcleaners, setlinkedcleaners] = useState({});
    const [optionArray, setoptionArray] = useState([]);
    const [selectedCleaner, setselectedCleaner] = useState(null);
    const [loading, setLoading] = useState(true);


    const t = props.translation

    //t("CheckIn")
    // create navigation object if needed
    const navigate = useNavigate();


    const saveNoShow = async () => {
        if (selectedCleaner !== null && selectedCleaner !== "null") {
            const response = await updateemployeetoroosterv2({
                werknemer_Id: selectedCleaner,
                planned: 0
            });

            if (response.status !== 200) {
                setErrorMessage("Could not mark employee as no-show", response.message);
            }
            if (response.status === 200) {
                const emp = linkedcleaners[selectedCleaner].cleaner;
                emp.planned = 0;
                setMessage(emp.voornaam + " " + emp.achternaam + " marked as no-show");
                const emparray = { ...linkedcleaners };
                delete emparray[selectedCleaner];
                setlinkedcleaners(emparray);
            }
        }
    }


    async function fetchData() {
        setLoading(true);
        const response = await getMyLinkedhotels()
        const linkedhotelsresponse = await response.json()
        setlinkedhotels(linkedhotelsresponse.hotels);
        if (linkedhotelsresponse.hotels.length > 0) {
            for (const hotel of linkedhotelsresponse.hotels) {
                const res = await gethotelcleaners(hotel.hotel_Id);
                const data = await res.json();
                for (const cleaner of data.items) {
                    setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
                }
            }
        }
        setLoading(false);
    }
    //dop something after loading page
    useEffect(() => {
        fetchData();
    }, [props.rights]);

    useEffect(() => {
        if (Object.keys(linkedcleaners).length > 0) {
            const options = Object.keys(linkedcleaners).map((key) => {
                const emp = linkedcleaners[key].cleaner;
                return { value: key, label: `${emp.voornaam} ${emp.achternaam}` };
            })
            setoptionArray(options)
        }
    }, [linkedcleaners]);

    const selectchange = (option) => {
        setselectedCleaner(option ? option.value : null);
    }

    if (loading) return <LoadingSpinner />;

    return (
        <>
            <div id="main" className="Screendiv">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div id="content">
                    <div className="form">
                        {/* <h2>Selecteer afwezige medewerker</h2> */}
                        <label className='formtitleContentBox'>{t('Selecteer afwezige medewerker')}</label>
                        <br></br>
                        <div className="contentbox">
                            <div id="searchboxhotel" className="formElementfieldset_2">
                                <label className='labelcolor width200'>
                                    {t('Medewerker')}:
                                </label>
                                <Select
                                    id="employeeSelect"
                                    onChange={selectchange}
                                    options={optionArray}
                                    value={optionArray.find(opt => opt.value === selectedCleaner) || null}
                                    placeholder= {t('Kies een medewerker')}
                                    isSearchable
                                />
                                {/* <HotelRoosterSelection  isDisabled={false} data={{ fieldname: "nr_afd", selectedhotel: null, handleitemchange: setSelectedHotel }} t={t} valueneeded="hotel_id" checkapproval={true} css="date" selectedDate={selectedDate} /> */}
                            </div>
                            <br></br>
                             <div id="searchboxhotel" className="formElementfieldset_2">
                                <label className='labelcolor width200'>
                                   
                                </label>
                            <Button onClick={saveNoShow}> {t('Markeer als afwezig')}</Button>
                            </div>
                            <br></br>
                        </div>
                        <div class="result" id="resultMessage"></div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default NotPresent